var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.963 4.002v2.04a.538.538 0 001.073 0v-2.04a.538.538 0 00-1.073 0zM12.036 19.998v-2.04a.538.538 0 00-.536-.537c-.322 0-.537.215-.537.537v2.04a.538.538 0 001.073 0zM17.458 11.463h2.04a.538.538 0 010 1.073h-2.04A.538.538 0 0116.92 12c0-.322.215-.537.537-.537zM15.311 8.135l-3.489 3.49a.914.914 0 00-.537 0L6.508 6.846a.519.519 0 00-.751 0 .519.519 0 000 .752l4.777 4.777c-.107.376 0 .805.322 1.073.107.108.322.215.483.269a1.097 1.097 0 001.342-1.074c0-.107 0-.16-.054-.268l3.49-3.49c.429-.536-.323-1.234-.806-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.09.513A11.524 11.524 0 00.013 12.59C.335 18.441 5.06 23.165 10.91 23.487c6.817.322 12.399-5.26 12.077-12.077C22.665 5.559 17.94.835 12.09.513zm.323 21.363c-6.173.537-11.326-4.616-10.79-10.789.43-4.723 4.241-8.534 8.965-8.963 6.172-.537 11.325 4.616 10.788 10.789-.429 4.723-4.24 8.534-8.964 8.963z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--clock-cda144621f87031feb44b67c1f57b7a6.svg";
export { SvgIconUiClock as Component };